export const UNMATCHED_FILE_STATUS = {
  Unknown: 'Unknown',
  Trusted: 'Trusted',
  Ignored: 'Ignored',
};
export const UNMATCHED_FILE_GROUP_STATUS_MIXED = 'Mixed'; // Status for groups of files, not persisted in DB

const UNMATCHED_FILE_STATUS_MAPPING = [
  { value: UNMATCHED_FILE_STATUS.Unknown, label: 'Unknown', color: '#9E9E9E' },
  { value: UNMATCHED_FILE_STATUS.Trusted, label: 'Trusted', color: '#4CAF50' },
  { value: UNMATCHED_FILE_STATUS.Ignored, label: 'Ignored', color: '#F44336' },
  { value: UNMATCHED_FILE_GROUP_STATUS_MIXED, label: 'Mixed', color: '#FF9800' },
];

export const getUnmatchedFileStatusLabel = value =>
  UNMATCHED_FILE_STATUS_MAPPING.find(item => item.value === value)?.label ??
  (value != null && value !== '' ? String(value).replace(/([a-z])([A-Z])/g, '$1 $2') : '');

export const getUnmatchedFileStatusColor = value =>
  UNMATCHED_FILE_STATUS_MAPPING.find(item => item.value === value)?.color || '#9E9E9E';
